export const ADD_TOAST = 'ADD_TOAST'
export const addToast = (toast) => ({
    type: ADD_TOAST,
    payload: toast,
})

export const REMOVE_TOAST = 'REMOVE_TOAST'
export const removeToast = (toastId) => ({
    type: REMOVE_TOAST,
    payload: toastId,
})
